import "./RemainingPagesResponsive.css";
import AdminLayout from "../components/AdminLayout";
import { TeamSection } from "./Settings";

// Admin-only page: list of workers/admins, add worker, reset password, disable.
export default function Team() {
  return (
    <AdminLayout>
      <main className="p-3 sm:p-6 space-y-5 agp-rem-page">
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm px-6 py-5">
          <h1 className="text-2xl font-extrabold text-slate-900">Team</h1>
          <p className="text-sm text-slate-400 mt-0.5">Add workers, see what each person has sent, and manage access.</p>
        </div>
        <TeamSection standalone />
      </main>
    </AdminLayout>
  );
}
